// Organization security policy as the web app applies it (the server enforces it; this decides
// what the screen shows). See apps/server/src/services/org-security.ts.
import type { WorkspaceSummary } from '@landmaniq/shared';

/** Pages a member can still open while their organization blocks them for missing two-factor. */
const OPEN_WHILE_BLOCKED = [/^\/settings(\/|$)/];

export type TwoFactorGate = { kind: 'blocked' } | { kind: 'grace'; deadline: string } | null;

/** Whether the selected workspace's two-factor requirement blocks this page, warns, or does nothing. */
export function twoFactorGate(workspace: Pick<WorkspaceSummary, 'kind' | 'security'> | null | undefined, pathname: string): TwoFactorGate {
  const s = workspace?.kind === 'organization' ? workspace.security : undefined;
  if (!s?.twoFactorRequired) return null;
  if (s.twoFactorBlocked) return OPEN_WHILE_BLOCKED.some((re) => re.test(pathname)) ? null : { kind: 'blocked' };
  return s.twoFactorDeadline ? { kind: 'grace', deadline: s.twoFactorDeadline } : null;
}

/** The organization turned Scout and AI off (as opposed to a package without AI). */
export function aiOffByOrganization(workspace: Pick<WorkspaceSummary, 'entitlements'> | null | undefined): boolean {
  return !!workspace?.entitlements.aiDisabledByOrganization;
}

/** "October 8" style date for the grace deadline. */
export function deadlineLabel(iso: string): string {
  return new Date(iso).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
}
